export class AddUserRequestModel {
  firstName: string;
  lastName: string;
  email: string;
  pwd: string;
  roleId: number;
  appFeatures: string;
  rptFeatures: string;
  externalID: string;
  executorId: string;
}
